(ns frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.controller
  (:require
   [frontend.ui.component.lp-portal.bar-chart.view :as bar-chart]
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

;; TODO change name of this component to largest-investments
;; as it is used by PE and RE with different names?

(defn- largest-investments
  [labels navs pcts]
  ;; TODO -> FIX SORTING in all reports
  ;; TODO -> show navs in tooltip -> NICE to have - show CapMan
  (let [datas (->> (map (fn [l p]
                          [l p])
                        labels
                        pcts)
                   (sort-by second)
                   (reverse)
                   (take 5))
        labels (->> datas
                    (map first)
                    (doall))
        data (->> datas
                  (map second)
                  (map #(* 100 %))
                  (doall))]
    {:chart       {:type   :bar
                   :height "300"}
     :tooltip     {:outside         true
                   :useHtml         true
                   :backgroundColor (theme/color [:page-bg :bg])
                   :style           {:opacity         1
                                     :backgroundColor (theme/color [:page-bg :bg])}
                   :enabled         false}
     :plotOptions {:series {:colorByPoint true
                            :dataLabels   {:enabled true
                                           :style   {:color       "contrast"
                                                     :textOutline false}
                                           :format  "{y:.1f}%"}}}
     :colors      (or (util/custom-colors)
                      (util/gradient-colors [:lp-report :chart :bar :gradient-start]
                                            [:lp-report :chart :bar :gradient-end]
                                            (count data)))
     :legend      {:enabled false}
     :xAxis       {:categories    labels
                   :lineColor     (theme/color [:chart :x-axis :line])
                   :gridLineColor (theme/color [:chart :x-axis :grid-line])}
     :yAxis       {:visible       false
                   :lineColor     (theme/color [:chart :y-axis :line])
                   :gridLineColor (theme/color [:chart :y-axis :grid-line])
                   }
     :series      [{:data data}]}))

;; Used by private-equity fund reports
(defn largest-investments-at-fair-value
  [{:keys [labels fair-value-pct] :as chart-data}]
  (bar-chart/column-top-n
   (assoc chart-data
     :title ""
     :values (map #(* % 100) fair-value-pct)
     :formatter bar-chart/point-formatter-pct
     :top-n 5)))

;; Used by real-estate fund reports
(defn largest-investments-by-nav
  [{:keys [labels nav nav-pct]}]
  (largest-investments labels nav nav-pct))
